const clearErrors = state => ({
  ...state,
  errors: []
});

export default clearErrors;
